const FormOpinion = () => {
    return (
        <div className="h-fit w-full p-4 md:p-8 flex flex-col gap-6">
            <div className="flex flex-row gap-1 items-center justify-center text-purple-900 font-bold">
                <h1 className="text-4xl">Tu opinión</h1>
                <h1 className="text-4xl">es importante</h1>
            </div>
            <div className="w-full h-1 bg-purple-900" />
            <form className="w-full flex flex-col gap-4">
                <input
                    type="text"
                    placeholder="Tu nombre"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <input
                    type="text"
                    placeholder="Lugar de procedencia"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <select
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 text-gray-700 bg-gray-100"
                    defaultValue=""
                >
                    <option value="" disabled>Calidad del servicio</option>
                    <option value="excelente">Excelente</option>
                    <option value="buena">Buena</option>
                    <option value="regular">Regular</option>
                    <option value="mala">Mala</option>
                    <option value="pésima">Pésima</option>
                </select>
                <input
                    type="text"
                    placeholder="Puesto"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <textarea
                    placeholder="Comentarios"
                    rows="3"
                    className="border border-gray-300 p-3 rounded-md resize-none outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                ></textarea>
                <button
                    type="submit"
                    className="text-white hover:text-purple-900 bg-purple-900 hover:bg-white hover:border-2 hover:border-purple-900 py-2 px-4 rounded-md transition"
                >
                    Enviar opinión
                </button>
            </form>
        </div>
    );
};

export default FormOpinion;